// src/components/ResponsiveSvg/ResponsiveSvg.jsx
import React from 'react';
import styles from './ResponsiveSvg.module.css';

const ResponsiveSvg = () => {
  return (
    <section className={styles.section}id="journey">
      <div className={styles.container}>
        <div className={styles.desktopSvg}>
          <img src="/images/svg/desktop22.svg" alt="Our journey visualization - Desktop version" className={styles.svg} />
        </div>
        <div className={styles.mobileSvg}>
          <img src="/images/svg/mobile11.svg" alt="Our journey visualization - Mobile version" className={styles.svg} />
        </div>
      </div>
    </section>
  );
};

export default ResponsiveSvg;